"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HeroImage = void 0;

var _preact = require("preact");

var _absoluteUrlRuntime = require("@insided/shared/utils/absoluteUrlRuntime");

var _classnames = _interopRequireDefault(require("classnames"));

var _Button = _interopRequireDefault(require("../../control-components/ui-components/Button"));

var _HeroImagePreview = require("./HeroImagePreview");

var HeroImage = function HeroImage(props) {
  var src = props.src,
      dimentionLabel = props.dimentionLabel,
      onEdit = props.onEdit,
      onRemove = props.onRemove,
      onUpload = props.onUpload,
      buttonClassName = props.buttonClassName,
      uploadButtonClassName = props.uploadButtonClassName;

  if (src) {
    return (0, _preact.h)("div", {
      className: "hero-image-container"
    }, (0, _preact.h)(_HeroImagePreview.HeroImagePreview, {
      src: (0, _absoluteUrlRuntime.resolveUrl)(src),
      dimentionLabel: dimentionLabel
    }), (0, _preact.h)("div", {
      className: "hero-image_buttons"
    }, (0, _preact.h)(_Button.default, {
      type: "button",
      className: (0, _classnames.default)(buttonClassName, 'btn--insided-secondary-brand'),
      onClick: onEdit
    }, "Edit"), (0, _preact.h)(_Button.default, {
      type: "button",
      className: (0, _classnames.default)(buttonClassName, 'btn--insided-secondary-brand', 'btn-delete'),
      onClick: onRemove
    }, "Remove")));
  }

  return (0, _preact.h)("div", null, (0, _preact.h)(_Button.default, {
    type: "button",
    className: (0, _classnames.default)(uploadButtonClassName, 'btn--insided-secondary-brand'),
    onClick: onUpload
  }, "Upload image"));
};

exports.HeroImage = HeroImage;